<template>
  <div>
    <div class="list-area">
      <div v-if="noData" class="no-contents">조회 결과가 없습니다</div>
      <vertical-list-slider
        :listItems="listItems"
        :componentStyle="componentStyle"
        :isActiveVue="isActiveVue"
      ></vertical-list-slider>
    </div>
  </div>
</template>

<script>
import VerticalListSlider from "../components/slider/VerticalListSlider.vue";

export default {
  data() {
    return {
      isActiveVue: true,
      componentStyle: {
        width: Number(window.innerWidth) == 1920 ? "358px" : "244px",
        height: Number(window.innerWidth) == 1920 ? "316px" : "227px",
        left: Number(window.innerWidth) == 1920 ? "176px" : "120px",
      },
    noData: false,
    };
  },

  computed: {
    listItems() {
      return this.$store.getters.programList;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
  },

  watch: {
    fousedView(val) {
      if (this.isActiveVue == true && val == "default" && this.noData == true) {
        this.$store.commit("SET_FOCUSED_VIEW", "gnb");
      }
    },
  },

  components: {
    VerticalListSlider,
  },

  created() {
    this.$progress.$emit("on:progress");

    this.$store.commit("SET_FOCUSED_VIEW", "default");

    this.$store
      .dispatch("FETCH_PROGRAM_LIST")
      .then((response) => {
        this.$progress.$emit("off:progress");

        if (!response || !response.data || response.data.length == 0) {
          this.noData = true;
          this.$store.commit("SET_FOCUSED_VIEW", "gnb");
        }
      })
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.list-area {
  position: relative;
}
.no-contents {
  font-size: 32px;
  left: 650px;
  top: 460px;
  width: 400px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: rgba(30, 30, 30, 0.95);
}

@media all and (min-width:0px) and (max-width:1280px){
  .list-area {
    width: 100vw;
    height: 100vh;
  }

  .no-contents {
    font-size: 32px;
    width: 400px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: rgba(30, 30, 30, 0.95);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  } 
}
</style>